/* eslint-disable no-unused-expressions, @typescript-eslint/no-unused-expressions, no-shadow, @typescript-eslint/no-shadow */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { enableDebugTools } from '@angular/platform-browser';
import { ApplicationRef, enableProdMode } from '@angular/core';

import { config } from './app/config/clarity.constants';

if (config.environment.environment === 'production') {
  // Enable in prod
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, [])
  .then((moduleRef) => {
    if (config.environment.environment !== 'production') {

      const applicationRef = moduleRef.injector.get(ApplicationRef);
      const componentRef = applicationRef.components[0];

      enableDebugTools(componentRef);

      // Ensure Angular destroys itself on hot reloads.
      // if (window['ngRef']) {
      //   window['ngRef'].destroy();
      // }

      window['ngAppRef'] = applicationRef;
      window['ngCompRef'] = componentRef;
      window['ngModRef'] = moduleRef;

      /*
      // Enable in development to help debugging --> e.g. dbg('ClarityConfig')

      window['dbg'] = (className) => {
        const found = ApplicationRef.componentFactoryResolver['_ngModule']._providers
          .filter((obj) => {
            return obj && obj.constructor.name === className;
          });

        return found && found.length > 0 ? found[0] : null;
      };

      // Or if it doesn't work, try this webpack hacking:

      function getWebpackInternals() {
        return new Promise((resolve) => {
          const id = 'fakeId' + Math.random();
          window['webpackJsonp'].push(["web", {
              [id]: function(module, __webpack_exports__, __webpack_require__) {
                  resolve([module, __webpack_exports__, __webpack_require__])
              }
          },[[id]]]);
        });
      }

      function getModuleByName(moduleName) {
        return getWebpackInternals().then(([_, __webpack_exports__, __webpack_require__]) => {
          const modules = __webpack_require__.c;

          const moduleFound = Object.values(modules).find(module => {
            if (module && module.exports && module.exports[moduleName]) return true;
          });

          if (!moduleFound) {
            console.log('couldnt find module ' + moduleName);
            return;
          }

          return moduleFound.exports[moduleName];
        })
      }

      getModuleByName('UserDataSyncChannelService').then(service => {
        window['userDataSyncChannelService'] = ngModRef.get(service);
      })

      */
    }
  })
  .catch(error => {
    console.error(error);
  });
